import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../../../../service";
import {
    IEntityWithIDTranslations,
    IEntityWithTranslations,
    IErrorResponse,
    IRootState
} from "../../../../../../../types";
import {
    deletedRestoreStudentsInstitute,
    deletedStudentsInstitute,
    setStudentsInstitute, setStudentsInstituteRestore, updateStudentsInstitute
} from "./studentInstituteSlice";



const GetStudentsInstitute = createAsyncThunk(
    "get/students/institute",
    async (_, { dispatch,rejectWithValue,getState }) => {
        try {
            const response = await request.get("/student-educational-institution");
            const lang = getState()  as IRootState
            const defaultLanguage = lang.languages.defaultLanguage

            dispatch(setStudentsInstitute({data:response.data,defaultLanguage}));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const SetStudentsInstitute = createAsyncThunk(
    "set/students/institute",
    async (data: IEntityWithTranslations, { rejectWithValue }) => {
        try {
            const response = await request.post("/student-educational-institution", data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const DeleteStudentsInstitute = createAsyncThunk(
    "delete/students/institute",
    async ( id : number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/student-educational-institution/${id}`);

            dispatch(deletedStudentsInstitute(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditStudentsInstitute = createAsyncThunk(
    "edit/students/institute",
    async (data: IEntityWithIDTranslations, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/student-educational-institution/${data.id}`, data);
            dispatch(updateStudentsInstitute(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const GetDeleteStudentsInstitute = createAsyncThunk(
    "get/delete/students/institute",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/student-educational-institution/deleted-items`);

            dispatch(setStudentsInstituteRestore(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const RestoreDeleteStudentsInstitute= createAsyncThunk(
    "restore/delete/students/institute",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/student-educational-institution/restore/${id}`);
            dispatch(deletedRestoreStudentsInstitute(id));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


export {
    GetStudentsInstitute,
    SetStudentsInstitute,
    DeleteStudentsInstitute,
    EditStudentsInstitute,
    GetDeleteStudentsInstitute,
    RestoreDeleteStudentsInstitute
};
